module.exports = __webpack_public_path__ + "img/icon-video.5ff7407c.jpg";